// Hooks
import { usePatientForm } from './hooks/usePatientForm'
import { usePatientValidation } from './hooks/usePatientValidation'
import { usePatientSearch } from './hooks/usePatientSearch'
import { useFormFieldVisibility } from './hooks/useFormFieldVisibility'
// Components
import PatientBasicInfoFields from './components/PatientBasicInfoFields'
import PatientMoreDetails from './components/PatientMoreDetails'

export default function PatientFormComponentV2({
  editMode = false,
  patientDetails,
  setPatientDetails,
  hidePatientNumber = false,
  hideInputValidations = false,
  makeAnonymousPatient,
  onFindingExistingPatient,
  addRelatedPatient,
  hideRelationShipDetails = false,
  clinicId,
  clinicBrandId,
  setMakeAnonymousPatient,
  importIdFieldLabel = 'Import Id',
  isAllowedToAddImportId = false,
  isAllowedToAddUHID = false,
  isForcingAnonymousPatient = false,
  moveEmailToMoreSettings = false,
  disablePatientSearch = false,
  showAdminFields = false,
  dontUseMoreDetailsAccordian,
  patientSearchApiSignature = '/api/secure/mentor/patient/list',
}) {
  // Initialize hooks
  const formHook = usePatientForm(
    patientDetails,
    setPatientDetails,
    makeAnonymousPatient,
    setMakeAnonymousPatient,
  )

  const validationHook = usePatientValidation(
    patientDetails,
    makeAnonymousPatient,
    hideInputValidations,
    hideRelationShipDetails,
  )

  const searchHook = usePatientSearch(
    patientDetails,
    clinicId,
    clinicBrandId,
    addRelatedPatient,
    onFindingExistingPatient,
    setMakeAnonymousPatient,
    patientSearchApiSignature,
  )

  const visibilityHook = useFormFieldVisibility({
    patientDetails,
    makeAnonymousPatient,
    isForcingAnonymousPatient,
    moveEmailToMoreSettings,
    hidePatientNumber,
    isAllowedToAddUHID,
    isAllowedToAddImportId,
    hideRelationShipDetails,
    initialVisibilityConfig: {
      communicationToPref: showAdminFields,
    },
  })

  return (
    <div className="d-flex flex-column gap-2">
      <PatientBasicInfoFields
        patientDetails={patientDetails}
        editMode={editMode}
        formHook={formHook}
        validationHook={validationHook}
        searchHook={searchHook}
        visibilityHook={visibilityHook}
        makeAnonymousPatient={makeAnonymousPatient}
        isForcingAnonymousPatient={isForcingAnonymousPatient}
        importIdFieldLabel={importIdFieldLabel}
        clinicId={clinicId}
        clinicBrandId={clinicBrandId}
        patientSearchApiSignature={patientSearchApiSignature}
        disablePatientSearch={disablePatientSearch}
      />

      <PatientMoreDetails
        dontUseMoreDetailsAccordian
        patientDetails={patientDetails}
        editMode={editMode}
        formHook={formHook}
        validationHook={validationHook}
        visibilityHook={visibilityHook}
        makeAnonymousPatient={makeAnonymousPatient}
      />
    </div>
  )
}
